<template>
  <div id="app">
    <div class="main_page">
      <topHeader v-if="header_show"></topHeader>
      <div :class="[header_show ?'common-scrollbar' :'' ]">
        <div class="home-content ">
          <router-view v-on:header="header" v-on:footer="footer"></router-view>
        </div>
        <bottomFooter v-if="footer_show"></bottomFooter>
      </div>
      
    </div>

  </div>
</template>

<script>
import topHeader from '@/components/topHeader.vue'
import bottomFooter from '@/components/bottomFooter.vue'


export default {
  name: 'App',
  data(){
    return {
      header_show:true,
      footer_show:true,
    }
  },

  methods:{
    //是否显示头部
    header:function (bool) {
      this.header_show = bool;
    },
    //是否显示底部
    footer:function (bool) {
      this.footer_show = bool;
    }
  },
  components: {
    topHeader,
    bottomFooter
  }
}
</script>

<style scoped lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
  height: 100%;
}

.main_page {
  width: 100%;
  height: 100%;
  // overflow-x: hidden;
  position: relative;
}

.common-scrollbar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  // border: 1px solid #f00;
  min-height: calc(~"100vh - 206px");
  .home-content {
    width: 100%;
  }
}

.common-scrollbar::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.common-scrollbar::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #dcdee2;
}</style>
